import type { BodyRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { TranslationDataObject } from 'models/service';

type TranslateRequestBody = {
  translation: {
    id: string;
    language?: string;
    type: string;
  };
};

export const getTranslate = async ({ body }: BodyRequest<TranslateRequestBody>) =>
  apiClient.post<TranslationDataObject, ApiClientResponse<TranslationDataObject>>(routes.translation.get, body);
